export const numberToWords = (number) => {
  if (!number || isNaN(number) || number === 0) return "Không đồng";
  const strNumber = Math.round(number).toString();
  const chuSo = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
  const tien = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

  const row = [];
  for (let i = strNumber.length; i > 0; i -= 3) {
    row.push(strNumber.substring(Math.max(i - 3, 0), i));
  }

  const docHangChuc = (so, daydu) => {
    let chuoi = "";
    const chuc = Math.floor(so / 10);
    const donvi = so % 10;
    if (chuc > 1) {
      chuoi = " " + chuSo[chuc] + " mươi";
      if (donvi === 1) chuoi += " mốt";
    } else if (chuc === 1) {
      chuoi = " mười";
      if (donvi === 1) chuoi += " một";
    } else if (daydu && donvi > 0) {
      chuoi = " linh";
    }
    if (donvi === 5 && chuc >= 1) chuoi += " lăm";
    else if (donvi > 1 || (donvi === 1 && chuc === 0)) chuoi += " " + chuSo[donvi];
    return chuoi;
  };

  const docKhoi = (so, daydu) => {
    const tram = Math.floor(so / 100);
    const soDu = so % 100;
    if (daydu || tram > 0) {
      return ` ${chuSo[tram]} trăm${docHangChuc(soDu, true)}`;
    }
    return docHangChuc(soDu, false);
  };

  let ketQua = "";
  const viTri = row.length - 1;
  for (let i = viTri; i >= 0; i -= 1) {
    const soNhom = parseInt(row[i], 10);
    if (soNhom > 0) {
      ketQua += `${docKhoi(soNhom, i !== viTri)} ${tien[i]}`;
    }
  }

  const normalized = ketQua.trim();
  return `${normalized.charAt(0).toUpperCase() + normalized.slice(1)} đồng chẵn`;
};

const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ headerInfo }) => {
  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Phiếu Chi</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:12px; font-size:26px; font-weight:700; text-transform:uppercase; }
        .subtitle { text-align:center; margin-top:6px; font-style:italic; }
        .meta-right { text-align:right; margin-top:6px; line-height: 1.6; }
        .line { margin-top: 8px; line-height: 1.8; }
        .signatures { margin-top:22px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:20%; }
        .sign-spacer { height: 16px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Địa chỉ:</b> ${escapeHtml(headerInfo.address || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 02 - TT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">PHIẾU CHI</div>
      <div class="subtitle">Ngày ${escapeHtml(headerInfo.documentDate || ".../.../....")}</div>

      <div class="meta-right">
        <div>Quyển số: ${escapeHtml(headerInfo.bookNumber || "")}</div>
        <div>Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>
        <div>Nợ: ${escapeHtml(headerInfo.debitAccount || "")}</div>
        <div>Có: ${escapeHtml(headerInfo.creditAccount || "")}</div>
      </div>

      <div class="line">Họ và tên người nhận tiền: ${escapeHtml(headerInfo.payeeName || "")}</div>
      <div class="line">Địa chỉ: ${escapeHtml(headerInfo.payeeAddress || "")}</div>
      <div class="line">Lý do chi: ${escapeHtml(headerInfo.reason || "")}</div>
      <div class="line">Số tiền: ${fmtMoney(headerInfo.amount || 0)} (Viết bằng chữ): ${escapeHtml(headerInfo.amountText || "")}</div>
      <div class="line">Kèm theo: ${escapeHtml(headerInfo.attachments || "")} chứng từ gốc.</div>

      <div class="line">Đã nhận đủ số tiền (viết bằng chữ): ${escapeHtml(headerInfo.amountText || "")}</div>
      <div class="line">+ Tỷ giá ngoại tệ (vàng bạc, đá quý): ${fmtMoney(headerInfo.exchangeRate || 0)}</div>
      <div class="line">+ Số tiền quy đổi: ${fmtMoney(headerInfo.convertedAmount || 0)}</div>
      <div class="line">(Liên gửi ra ngoài phải đóng dấu)</div>

      <div class="signatures">
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Giám đốc</b></div>
          <div><i>(Ký, họ tên, đóng dấu)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Thủ quỹ</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div><i>Ngày... tháng... năm...</i></div>
          <div><b>Người lập phiếu</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Người nhận tiền</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
